// Auto-generated by rake javascript:manifest. Do not edit.
import type { Application } from '@hotwired/stimulus';

import AccessibleCardLinkController from './accessible_card_link_controller';
import ActiveCampaignNewslettersSubscriptionsController from './active_campaign/newsletters_subscriptions_controller';
import AdminSidebarController from './admin/sidebar_controller';
import AlertGroupToggleController from './alert_group_toggle_controller';
import AnchorTabsController from './anchor_tabs_controller';
import AuditsManualActionsController from './audits/manual_actions_controller';
import AuthoringDateInputController from './authoring_date_input_controller';
import AutosizeController from './autosize_controller';
import BulkSelectController from './bulk_select_controller';
import CadenceGridController from './cadence_grid_controller';
import CadenceGridFilterableController from './cadence_grid_filterable_controller';
import ChecklistsAttachmentController from './checklists/attachment_controller';
import ChecklistsAuditFieldController from './checklists/audit_field_controller';
import ChecklistsAuditFormController from './checklists/audit_form_controller';
import ChecklistsAuditListFieldController from './checklists/audit_list_field_controller';
import ChecklistsEditorController from './checklists/editor_controller';
import ChecklistsFormController from './checklists/form_controller';
import ChecklistsMeasurementArchivalController from './checklists/measurement_archival_controller';
import CollapseController from './collapse_controller';
import ComboboxController from './combobox_controller';
import ConcernsIntervallableFormController from './concerns/intervallable_form_controller';
import ConditionalFormFieldController from './conditional_form_field_controller';
import ConfirmController from './confirm_controller';
import CopyController from './copy_controller';
import CopyMarkdownController from './copy_markdown_controller';
import DashboardController from './dashboard_controller';
import DateInputController from './date_input_controller';
import DialogController from './dialog_controller';
import DisableInputController from './disable_input_controller';
import DismissibleController from './dismissible_controller';
import DocumentsPathSuggestionController from './documents/path_suggestion_controller';
import DomAttributesController from './dom_attributes_controller';
import EmojiPickerController from './emoji_picker_controller';
import EmployeeStartDateInputController from './employee_start_date_input_controller';
import EmployeesSiteAccessController from './employees/site_access_controller';
import ExpiryDateInputController from './expiry_date_input_controller';
import FileDirectUploadController from './file_direct_upload_controller';
import FilePreviewController from './file_preview_controller';
import FiltersController from './filters_controller';
import FormController from './form_controller';
import GraphsCalendarController from './graphs/calendar_controller';
import GraphsNetworkController from './graphs/network_controller';
import GraphsPerformanceQqController from './graphs/performance_qq_controller';
import IdenticonController from './identicon_controller';
import InputController from './input_controller';
import LabelsEditorController from './labels/editor_controller';
import LinkedFormFilterController from './linked_form_filter_controller';
import ListFilterController from './list_filter_controller';
import ListenableController from './listenable_controller';
import MarkableController from './markable_controller';
import MenuModalController from './menu_modal_controller';
import NamedRecurrenceIntervalsEditorController from './named_recurrence_intervals/editor_controller';
import NavbarController from './navbar_controller';
import NotificationsBellController from './notifications_bell_controller';
import OffCanvasBarController from './off_canvas_bar_controller';
import OffCanvasDialogController from './off_canvas_dialog_controller';
import OfflineContentController from './offline_content_controller';
import PopoverController from './popover_controller';
import PrintController from './print_controller';
import ProgressiveContentToggleController from './progressive_content_toggle_controller';
import RangeLabelsController from './range_labels_controller';
import RemotePopoverController from './remote_popover_controller';
import RemoteSelectController from './remote_select_controller';
import ReorderableController from './reorderable_controller';
import RowCheckboxController from './row_checkbox_controller';
import SafetyAlertController from './safety_alert_controller';
import ScriptLineNumbersLinksController from './script_line_numbers_links_controller';
import ScriptsDependencyConfigurationController from './scripts/dependency_configuration_controller';
import SearchBarModalController from './search_bar/modal_controller';
import SearchBarTokenController from './search_bar/token_controller';
import SearchBarTokenOperatorModalController from './search_bar/token_operator_modal_controller';
import SearchBarTokenTypeModalController from './search_bar/token_type_modal_controller';
import SearchBarTokenValueModalController from './search_bar/token_value_modal_controller';
import SearchBarController from './search_bar_controller';
import SelectController from './select_controller';
import SelectableTemplateToDomController from './selectable_template_to_dom_controller';
import SetInputController from './set_input_controller';
import ShareController from './share_controller';
import SidebarController from './sidebar_controller';
import SiteFormController from './site_form_controller';
import SiteSelectController from './site_select_controller';
import SiteSelectListController from './site_select_list_controller';
import SvgGraphController from './svg_graph_controller';
import TabsController from './tabs_controller';
import TasksDsInputController from './tasks/ds_input_controller';
import TasksFormController from './tasks/form_controller';
import TasksGroupDependentsController from './tasks/group_dependents_controller';
import TasksLiveController from './tasks/live_controller';
import TasksProgressbarController from './tasks/progressbar_controller';
import TasksResourcePickerController from './tasks/resource_picker_controller';
import TasksSnoozeController from './tasks/snooze_controller';
import TemplateToDomController from './template_to_dom_controller';
import TemplatedInputController from './templated_input_controller';
import TemplatesOwnedByRolesController from './templates/owned_by_roles_controller';
import TemplatesRoleRequirementsController from './templates/role_requirements_controller';
import TimeController from './time_controller';
import TimezoneInspectController from './timezone_inspect_controller';
import TiptapCodeController from './tiptap_code_controller';
import TiptapController from './tiptap_controller';
import ToastController from './toast_controller';
import TodosAssignedController from './todos/assigned_controller';
import TodosBulkActionsController from './todos/bulk_actions_controller';
import TodosDsInputComboboxController from './todos/ds_input_combobox_controller';
import TodosDsInputController from './todos/ds_input_controller';
import TodosFormController from './todos/form_controller';
import TodosLabelsController from './todos/labels_controller';
import TodosMessageHistoryController from './todos/message_history_controller';
import TodosSelectTemplateController from './todos/select_template_controller';
import TodosSnoozeController from './todos/snooze_controller';
import TrainingsNudgeController from './trainings/nudge_controller';
import TreeFilterController from './tree_filter_controller';
import TurboStreamLinkController from './turbo_stream_link_controller';
import ValueNumericConstraintController from './value_numeric_constraint_controller';

export function registerControllers(application: Application) {
  application.register('accessible-card-link', AccessibleCardLinkController);
  application.register('active-campaign--newsletters-subscriptions', ActiveCampaignNewslettersSubscriptionsController);
  application.register('admin--sidebar', AdminSidebarController);
  application.register('alert-group-toggle', AlertGroupToggleController);
  application.register('anchor-tabs', AnchorTabsController);
  application.register('audits--manual-actions', AuditsManualActionsController);
  application.register('authoring-date-input', AuthoringDateInputController);
  application.register('autosize', AutosizeController);
  application.register('bulk-select', BulkSelectController);
  application.register('cadence-grid', CadenceGridController);
  application.register('cadence-grid-filterable', CadenceGridFilterableController);
  application.register('checklists--attachment', ChecklistsAttachmentController);
  application.register('checklists--audit-field', ChecklistsAuditFieldController);
  application.register('checklists--audit-form', ChecklistsAuditFormController);
  application.register('checklists--audit-list-field', ChecklistsAuditListFieldController);
  application.register('checklists--editor', ChecklistsEditorController);
  application.register('checklists--form', ChecklistsFormController);
  application.register('checklists--measurement-archival', ChecklistsMeasurementArchivalController);
  application.register('collapse', CollapseController);
  application.register('combobox', ComboboxController);
  application.register('concerns--intervallable-form', ConcernsIntervallableFormController);
  application.register('conditional-form-field', ConditionalFormFieldController);
  application.register('confirm', ConfirmController);
  application.register('copy', CopyController);
  application.register('copy-markdown', CopyMarkdownController);
  application.register('dashboard', DashboardController);
  application.register('date-input', DateInputController);
  application.register('dialog', DialogController);
  application.register('disable-input', DisableInputController);
  application.register('dismissible', DismissibleController);
  application.register('documents--path-suggestion', DocumentsPathSuggestionController);
  application.register('dom-attributes', DomAttributesController);
  application.register('emoji-picker', EmojiPickerController);
  application.register('employee-start-date-input', EmployeeStartDateInputController);
  application.register('employees--site-access', EmployeesSiteAccessController);
  application.register('expiry-date-input', ExpiryDateInputController);
  application.register('file-direct-upload', FileDirectUploadController);
  application.register('file-preview', FilePreviewController);
  application.register('filters', FiltersController);
  application.register('form', FormController);
  application.register('graphs--calendar', GraphsCalendarController);
  application.register('graphs--network', GraphsNetworkController);
  application.register('graphs--performance-qq', GraphsPerformanceQqController);
  application.register('identicon', IdenticonController);
  application.register('input', InputController);
  application.register('labels--editor', LabelsEditorController);
  application.register('linked-form-filter', LinkedFormFilterController);
  application.register('list-filter', ListFilterController);
  application.register('listenable', ListenableController);
  application.register('markable', MarkableController);
  application.register('menu-modal', MenuModalController);
  application.register('named-recurrence-intervals--editor', NamedRecurrenceIntervalsEditorController);
  application.register('navbar', NavbarController);
  application.register('notifications-bell', NotificationsBellController);
  application.register('off-canvas-bar', OffCanvasBarController);
  application.register('off-canvas-dialog', OffCanvasDialogController);
  application.register('offline-content', OfflineContentController);
  application.register('popover', PopoverController);
  application.register('print', PrintController);
  application.register('progressive-content-toggle', ProgressiveContentToggleController);
  application.register('range-labels', RangeLabelsController);
  application.register('remote-popover', RemotePopoverController);
  application.register('remote-select', RemoteSelectController);
  application.register('reorderable', ReorderableController);
  application.register('row-checkbox', RowCheckboxController);
  application.register('safety-alert', SafetyAlertController);
  application.register('script-line-numbers-links', ScriptLineNumbersLinksController);
  application.register('scripts--dependency-configuration', ScriptsDependencyConfigurationController);
  application.register('search-bar--modal', SearchBarModalController);
  application.register('search-bar--token', SearchBarTokenController);
  application.register('search-bar--token-operator-modal', SearchBarTokenOperatorModalController);
  application.register('search-bar--token-type-modal', SearchBarTokenTypeModalController);
  application.register('search-bar--token-value-modal', SearchBarTokenValueModalController);
  application.register('search-bar', SearchBarController);
  application.register('select', SelectController);
  application.register('selectable-template-to-dom', SelectableTemplateToDomController);
  application.register('set-input', SetInputController);
  application.register('share', ShareController);
  application.register('sidebar', SidebarController);
  application.register('site-form', SiteFormController);
  application.register('site-select', SiteSelectController);
  application.register('site-select-list', SiteSelectListController);
  application.register('svg-graph', SvgGraphController);
  application.register('tabs', TabsController);
  application.register('tasks--ds-input', TasksDsInputController);
  application.register('tasks--form', TasksFormController);
  application.register('tasks--group-dependents', TasksGroupDependentsController);
  application.register('tasks--live', TasksLiveController);
  application.register('tasks--progressbar', TasksProgressbarController);
  application.register('tasks--resource-picker', TasksResourcePickerController);
  application.register('tasks--snooze', TasksSnoozeController);
  application.register('template-to-dom', TemplateToDomController);
  application.register('templated-input', TemplatedInputController);
  application.register('templates--owned-by-roles', TemplatesOwnedByRolesController);
  application.register('templates--role-requirements', TemplatesRoleRequirementsController);
  application.register('time', TimeController);
  application.register('timezone-inspect', TimezoneInspectController);
  application.register('tiptap-code', TiptapCodeController);
  application.register('tiptap', TiptapController);
  application.register('toast', ToastController);
  application.register('todos--assigned', TodosAssignedController);
  application.register('todos--bulk-actions', TodosBulkActionsController);
  application.register('todos--ds-input-combobox', TodosDsInputComboboxController);
  application.register('todos--ds-input', TodosDsInputController);
  application.register('todos--form', TodosFormController);
  application.register('todos--labels', TodosLabelsController);
  application.register('todos--message-history', TodosMessageHistoryController);
  application.register('todos--select-template', TodosSelectTemplateController);
  application.register('todos--snooze', TodosSnoozeController);
  application.register('trainings--nudge', TrainingsNudgeController);
  application.register('tree-filter', TreeFilterController);
  application.register('turbo-stream-link', TurboStreamLinkController);
  application.register('value-numeric-constraint', ValueNumericConstraintController);
}
